import Dinero from "dinero.js";
import { roundCurrency } from "./currency";
import { isNonEmptyString, isNumber } from "./common";
import { dateToMoment } from "./date";

export const formatCurrency = (
  value: number,
  currencySymbol: Dinero.Currency = "USD"
): string => {
  if (!isNumber(value)) {
    value = 0.0;
  }

  let result;

  try {
    result = Dinero({
      amount: roundCurrency(roundCurrency(value) * 100),
      currency: currencySymbol,
    }).toFormat(`$0,0.00`);
  } catch (error) {
    result = "$0.00";
  }

  return result;
};

export const formatAxiosError = (error?: any, addStatusInfo?: boolean) => {
  return error?.response
    ? `${
        addStatusInfo
          ? `${error.response.statusText} (${error.response.status})`
          : ""
      }${addStatusInfo && isNonEmptyString(error.response.data) ? ": " : ""}${
        isNonEmptyString(error.response.data) ? `${error.response.data}` : ""
      }`
    : error?.message
    ? error.message
    : "Unknown error";
};

export const formatName = (
  firstName?: string,
  lastName?: string,
  onlyInitials: boolean = false
): string => {
  let _firstName = firstName?.trim().split('').map((w,i)=>!i ? w.toUpperCase() : w).join('');
  let _lastName = lastName?.trim().split('').map((w,i)=>!i ? w.toUpperCase() : w).join('');

  if (onlyInitials) {
    if (!!_firstName) {
      _firstName = _firstName.at(0);
    }
    if (!!_lastName) {
      _lastName = _lastName.at(0);
    }
  }

  return `${!!_firstName ? _firstName : ""}${
    !!_firstName && !!_lastName && !onlyInitials ? " " : ""
  }${!!_lastName ? _lastName : ""}`;
};

export const formatAddress = (
  city?: string,
  state?: string,
  zip?: string
): string => {
  let _city = city?.trim();
  let _state = state?.trim();
  let _zip = zip?.trim();

  return `${!!_city ? _city : ""}${
    !!_city && (!!_state || !!_zip) ? ", " : ""
  }${!!_state ? _state : ""}${(!!_city || !!_state) && !!_zip ? " " : ""}${
    !!_zip ? _zip : ""
  }`;
};

export const formatDateToUTC = (date: Date | string): string | undefined => {
  const m = dateToMoment(date);

  return m && m.isValid() ? m.utc().format("MM/DD/YYYY hh:mm a z") : undefined;
};

export const formatDateToPST = (date: Date | string): string | undefined => {
  const m = dateToMoment(date);

  return m?.isValid()
    ? m?.tz("America/Los_Angeles")?.format("MM/DD/YYYY hh:mm a z")
    : undefined;
};
